import { itemCategoryDeleteApi } from "../../api/itemCategory/itemCategoryDeleteApi"

type PayloadShape = Parameters<typeof itemCategoryDeleteApi>[0]

export async function itemCategoryDeleteService(payload: PayloadShape, token: string) {
	return await itemCategoryDeleteApi(payload, token)
}
